export function handleResponse(response) {
    return response.text().then(text => {
        
        if (!response.ok) {
            const data = text;
            if ([401, 403].indexOf(response.status) !== -1) {
                // auto logout if 401 Unauthorized or 403 Forbidden response returned from api
                window.location.reload(true);
            }

            const error = (data && data.message) || response.statusText;
            // console.log(data)
            return Promise.reject(error);
        }else{
            const data = text && JSON.parse(text);
            // console.log(data)
            return data;
        }
    });
}